	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.lib.math.Color4;


//////////////////
// WEBPACK FOOTER
// ./~/grimoirejs-math/ref/Color4.js
// module id = 27
// module chunks = 0